// extracted by mini-css-extract-plugin
export default {"productDescription":"V--z","featuredDescription":"W--z","description":"X--z","more":"Y--z","descriptionSku":"Z--z"};